import { NULL_VALUE } from 'constants/displayConstants';

import { seatByPositionName } from './seatCatalog';

type RosterMemberPositions = {
  userId: string;
  incidentPositions: { positionName: string }[];
};

/**
 * The seat slug for the first roster position the user holds that has a home in
 * the seat catalog, in roster order. Null when the user holds none.
 */
export function firstSeatSlugForPositions(
  positionNames: readonly (string | null | undefined)[]
): string | null {
  for (const name of positionNames) {
    if (!name || name === NULL_VALUE) continue;
    const seat = seatByPositionName(name);
    if (seat) return seat.slug;
  }
  return null;
}

/** My Assignment target: the current user's first seated position, as a slug. */
export function myAssignmentSlug(
  roster: readonly RosterMemberPositions[] | undefined,
  userGuid: string | null | undefined
): string | null {
  if (!userGuid) return null;
  const member = roster?.find((entry) => entry.userId === userGuid);
  return firstSeatSlugForPositions(
    (member?.incidentPositions ?? []).map((position) => position.positionName)
  );
}

export const MY_ASSIGNMENT_NONE_MESSAGE =
  'You are not seated in a position with a workspace on this incident.';
